import type { HttpClient } from '@/lib/http/client.js'
import type { UsageReport, UsageReportQuery } from '@/types/report/report.type.js'

/**
 * `admin/reports`, verified against `usage-report-admin.controller.ts`.
 *
 * One route, not four: every figure shares a window and an optional shop, and separate
 * calls would let a funnel from one period sit beside a breakdown from another.
 */
export interface ReportService {
  usage: (query: UsageReportQuery) => Promise<UsageReport>
}

export function createReportService(http: HttpClient): ReportService {
  return {
    usage: (query) => http.get<UsageReport>('admin/reports/usage', { query: { ...query } }),
  }
}
